import { promotionalOfferCrudConfig } from '@/config/objects/promotional-offers';
import { CrudFormView, PageContainer } from '@startupquickstart/frontend';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Promotional Offer create/edit form page
 */
export function PromotionalOfferFormPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const itemId = id === 'new' ? undefined : id;
  const isEdit = !!itemId;

  const handleSuccess = (promotionalOffer: { id: string }) => {
    navigate(`/promotional-offers/${promotionalOffer.id}`);
  };

  const breadcrumbs = isEdit
    ? [
        { label: 'Home', href: '/' },
        { label: 'Promotional Offers', href: '/promotional-offers' },
        { label: 'Promotional Offer', href: `/promotional-offers/${itemId}` },
        { label: 'Edit', current: true },
      ]
    : [
        { label: 'Home', href: '/' },
        { label: 'Promotional Offers', href: '/promotional-offers' },
        { label: 'Create', current: true },
      ];

  return (
    <PageContainer>
      <CrudFormView
        config={promotionalOfferCrudConfig}
        itemId={itemId}
        breadcrumbs={breadcrumbs}
        onSuccess={handleSuccess}
      />
    </PageContainer>
  );
}
